import React, { useState } from "react";
import {
  capitalizeFirstLetter,
  getUserStatus,
  getGender,
  isAdminUser,
} from "utils/helper";
import {
  Typography,
  BeadCrumb,
  NotificationModal,
  OnboardingDetails,
} from "components";
import { useSelector } from "react-redux";
import { ROUTES } from "routes/routePaths";
import { RiArrowRightSLine } from "react-icons/ri";
// import { routes } from "routes/apiRoutes";
// import makeRequest from "services/makeRequest";
import { Link } from "react-router-dom";
import { AiOutlineEdit } from "react-icons/ai";
import userAvatar from "assets/images/user-avatar.png";
import successImage from "assets/images/agent-aggregator-success.jpg";
import EditUserModal from "pages/admin/users/UserManagement/UserProfile/EditUserModal";

const ProfilePage = () => {
  // const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [KYCView, setKYCView] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const { user } = useSelector((state) => state.user);

  //Get agent type or user type and determine not to show request to aggregator, consider onboarding state too. If he is been verified
  //Show agent code too
  const {
    email,
    firstname,
    gender,
    lastname,
    status,
    user_name,
    mobile,
    agent_id,
    roles,
  } = user;

  // const requestAgentAggregator = async () => {
  //   setLoading(true);
  //   setShowModal(true);

  //   try {
  //     const { data } = await makeRequest(
  //       "post",
  //       routes.agentAggregatorRequest(),
  //       {}
  //     );
  //     //     //check for successful response
  //     console.log(data);
  //     //showModal
  //     //make get request to get status again and remount component with current status
  //   } catch (err) {
  //     setLoading(false);
  //   }
  // };

  const renderDetails = [
    { label: "First Name", value: capitalizeFirstLetter(firstname) },
    { label: "Last Name", value: capitalizeFirstLetter(lastname) },
    { label: "User Name", value: capitalizeFirstLetter(user_name) },
    { label: "Gender", value: getGender(gender)?.label },
    { label: "Phone Number", value: mobile },
    { label: "Email", value: email },
    { label: "Role", value: roles[0] },
  ];

  return (
    <div className="dashboard-page-container">
      <div className="beadcrumb-margin">
        <BeadCrumb titles={["Users", "User Profile"]} />
      </div>
      <div className="mx-auto profile-container">
        {!isAdminUser(user) && (
          <div className="d-flex justify-content-end edit-profile-cta cursor-pointer">
            <Typography
              variant="caption2"
              onClick={() => setIsEditModalOpen(true)}
            >
              Edit Profile <AiOutlineEdit />
            </Typography>
          </div>
        )}

        <div className="user-profile-header d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <img src={userAvatar} alt="" height="45px" />
            <div className="mx-3">
              <Typography variant="body4" state="primary">
                {capitalizeFirstLetter(firstname)}{" "}
                {capitalizeFirstLetter(lastname)}
              </Typography>
              {!isAdminUser(user) && (
                <Typography variant="body3" state="primary">
                  {user?.agent_code}
                </Typography>
              )}
            </div>
          </div>
          <div>
            {!isAdminUser(user) && (
              <Link to={ROUTES.viewPmAccounts}>
                <Typography
                  variant="caption1"
                  state="secondary"
                  className={"text-underline text-right mb-1"}
                >
                  View PM Accounts <RiArrowRightSLine fontSize="16px" />
                </Typography>
              </Link>
            )}
            <Typography variant="body4" component="span" state="primary">
              Status
            </Typography>
            :{" "}
            <Typography
              variant="body3"
              component="span"
              style={{ color: getUserStatus(status)?.color }}
            >
              {getUserStatus(status)?.text}
            </Typography>
          </div>
        </div>

        {/* {!isAdminUser(user) && !user.is_aggregator && (
          <div className="row ">
            <div className="col-lg-9 mb-4">
              <Typography variant="body3">
                You can become an aggregator by registering downline agents
                under your profile and earn extra commision on every agent
                transactions. Click this button th submit a request
              </Typography>
            </div>
            <div className="col-8 col-lg-3 d-flex justify-content-end mb-4">
              <Button
                label="Become An Aggregator"
                style={{ height: "2.5rem" }}
                loading={loading}
                onClick={requestAgentAggregator}
              />
            </div>
          </div>
        )} */}

        <div className="row">
          <div className="col-md-6">
            <Typography
              state={!KYCView ? "primary" : "grey"}
              variant="body0"
              className={`profile-title mt-4 ${
                !KYCView ? "profile-title--active" : ""
              } cursor-pointer`}
              onClick={() => setKYCView(false)}
            >
              Profile Information
            </Typography>
          </div>

          {!isAdminUser(user) && (
            <div className="col-md-6">
              <Typography
                state={KYCView ? "primary" : "grey"}
                variant="body0"
                className={`profile-title mt-4 ${
                  KYCView ? "profile-title--active" : ""
                } cursor-pointer`}
                onClick={() => setKYCView(true)}
              >
                KYC Details
              </Typography>
            </div>
          )}
        </div>
        {!KYCView ? (
          <div style={{ marginTop: "2rem" }}>
            <div className="row user-detail-container">
              {renderDetails.map(({ label, value }, key) => (
                <div className="col-md-6 mt-3" key={key}>
                  <Typography>
                    {label}: &nbsp; &nbsp; {value}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ marginTop: "3rem" }}>
            <OnboardingDetails agentId={agent_id} />
          </div>
        )}
      </div>
      <NotificationModal
        showModal={showModal}
        image={<img src={successImage} alt="" width="170" />}
        onClose={() => {
          setShowModal(false);
        }}
        headerText="Request submitted Successfully"
        bodyText="Your request to become an aggregator has been submitted and you will be notified of your status in 48 hours."
      />
      <EditUserModal
        userInfo={{
          email: user.email,
          phoneNumber: user.mobile,
          id: user.user_id,
        }}
        isModalVisible={isEditModalOpen}
        setIsModalVisible={setIsEditModalOpen}
      />
    </div>
  );
};

export default ProfilePage;
